// removed by extract-text-webpack-plugin
module.exports = {"standardTable":"standardTable___1RY3H","tableAlert":"tableAlert___2T22W"};